/*消息中心埋点*/
import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  msgClientTab(flag) {
    const op = {
      1: '左侧导航栏-消息中心',
      2: '顶部导航栏消息气泡提示'
    };
    buryPoint.event({
      action: '消息中心-查看客户消息tab',
      eventCategory: '消息中心',
      eventLabel: op[flag]
    });
  },
  msgEventTab(flag) {
    const op = {
      1: '顶部导航栏消息气泡提示',
      2: '顶部导航栏消息下拉查看全部',
      3: 'Home页异常事件概览-查看全部异常事件',
      4: 'Home页异常事件概览-查看某类异常事件',
      5: 'Home页常用操作-查看异常事件',
      6: '左侧导航栏-event center',
      7: '消息中心-tab切换',
      8: '浏览器系统通知点击'
    };
    buryPoint.event({
      action: '消息中心-查看异常中心tab',
      eventCategory: '消息中心',
      eventLabel: op[flag]
    });
  },
  clientMsgFilter(flag) {
    const op = {
      1: '全部',
      2: '待处理'
    };
    buryPoint.event({
      action: '消息中心-客户消息筛选',
      eventCategory: '消息中心',
      eventLabel: op[flag]
    });
  },
  enterMsgDetail() {
    buryPoint.event({
      action: '消息中心-查看消息详情',
      eventCategory: '消息中心'
    });
  },
  trustMsgAgree(flag) {
    const op = {
      1: '消息列表',
      2: '消息详情侧滑面板'
    };
    buryPoint.event({
      action: '设备托管消息-同意',
      eventCategory: '设备托管消息',
      eventLabel: op[flag]
    });
  },
  trustMsgAgreeRes(errorCode) {
    const op = {
      LAP042001: '消息不存在',
      LAP042002: '消息已失效',
      LAP042003: '消息已过期或已处理',
      LAP042004: '消息属于被处理类型'
    };
    buryPoint.event({
      action: '设备托管消息-结果',
      eventCategory: '设备托管消息',
      eventLabel: op[errorCode]
    });
  },
  popMsgNotification(label) {
    buryPoint.event({
      action: '消息中心-弹出异常消息系统弹窗',
      eventCategory: '消息中心',
      eventLabel: label
    });
  },
  clickMsgNotification(label) {
    buryPoint.event({
      action: '消息中心-点击异常消息系统弹窗',
      eventCategory: '消息中心',
      eventLabel: label
    });
  }
};
